import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useStyles } from '../styles/index.js';

function HorizontalContainer({ children, className, dataTestId }) {
    const styles = useStyles();
    return jsx("div", { className: clsx(styles.root, className), "data-testid": dataTestId || 'container', children: children });
}
HorizontalContainer.displayName = 'HorizontalContainer';

export { HorizontalContainer };
